export const resDataFromBack = {
  status: true,
  data: {
    bulk: [
      {value: 1, label: " پوستی1 فله ای "},
      {value: 2, label: " پوستی2 فله ای "},
      {value: 3, label: " پوستی بال و کتف "},
      {value: 4, label: " بدون پوست بال و کتف "},
    ],
    package: [
      {value: 1, label: " پوستی ران ", packageList: [{value: 11, label: "بسته500گرمی"}]},
      {value: 2, label: " پوستی سینه ", packageList: [{value: 12, label: "بسته500گرمی"}]},
      {value: 3, label: " پوستی بال و کتف ", packageList: [{value: 13, label: "بسته500گرمی"}]},
      {value: 4, label: " بدون پوست بال و کتف ", packageList: [{value: 14, label: "بسته500گرمی"}]},
    ]

  }
}


export const myDataToWorkWithinComponent = {
  bulkListName: [], // اسامی فله  ای ها
  packageListName: [], // اسامی بسته ای ها که دارای انواع بسته می باشند
  barcodeList: [], // لیست کد بارکدها جهت نمایش برای افزودن با بارکد
  allProductList: [], // لیست کد بارکدها جهت نمایش برای افزودن با بارکد

  showBasedOn: "nameBtn", // barcodeBtn
  //
  selectedPackageName: "", // اون نام محصولی که توی لیست کاربر انتخاب کرده
  showPackageTypeList: false, // اینجا میگم لیست انواع بسته بندی رو نشون بده یا نه
  packageTypesList: [], // مثلا یه محصول انتخاب کرده و انواع بسته بندیش اینجا نمایش داده بشه
  selectedPackageTypeName: "", // اون نوع بسته بندی که توی لیست کاربر انتخاب کرده
  type: "", // backEnd wantToKnow type is bulk or pack

  selectedBarcodeValue: "",// اون بارکدی که کاربر توی لیست انتخاب کرده
  travellerValue: ""
}